import { SkeletonLoader } from '@toggle/design-system';
import styled from 'styled-components';

export const Root = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const LeftWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const RightWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const LogoLoader = styled(SkeletonLoader).attrs({
  areas: [
    {
      styles: {
        width: '32px',
        height: '32px',
        borderRadius: '40px',
      },
    },
  ],
})``;

export const NameLoader = styled(SkeletonLoader).attrs({
  areas: [
    {
      styles: {
        width: '114px',
        height: '24px',
        borderRadius: '8px',
      },
    },
  ],
})``;

export const RankLoader = styled(SkeletonLoader).attrs({
  areas: [
    {
      styles: {
        width: '48px',
        height: '24px',
        borderRadius: '8px',
      },
    },
  ],
})``;
